import { localStorageHelper } from '@frontend/auth-helpers';
import { sentry, ada, zendesk, accessibe } from '@frontend/tracking';
import { addPendoScript } from './pendo';
import { getSentryConfig } from './sentry-config';

export const loadThirdPartyScripts = () => {
  const accessibilityModeIsEnabled = localStorageHelper.get<{ state: { isEnabled: boolean } }>(
    'accessibility-mode-is-enabled'
  );
  if (import.meta.env.VITE_WEAVE_APP_URL.startsWith('https://app.getweave.com')) {
    try {
      sentry.init(getSentryConfig());
    } catch (e) {
      console.error(e);
    }
  }
  addPendoScript();
  ada.initialize();

  if (accessibilityModeIsEnabled && accessibilityModeIsEnabled.state.isEnabled) {
    accessibe.init();
  }

  const productionKey = '5f0e9de2-69da-4006-8555-255a938e8411';
  zendesk.appendScript({ apiKey: productionKey });
};
